import { Optional } from "common/utils/types";

import { Coordinate } from ".";

/** matches shipping CommonTrackerDetailSerializer */
export interface ITrackerDetail {
  id: number;
  status: TrackerStatus;
  message: string;
  datetime: Optional<string>;
  since: string;
  city: string;
  state: string;
  zipcode: string;
  coordinates: Optional<Coordinate>;
}

/** matches shipping CommonTrackerSerializer */
export interface ITracker {
  id: number;
  status: TrackerStatus;
  status_display: string;
  last_updated: Optional<string>;
  shipment_id: Optional<number>;
  tracking_code: string;
  est_delivery_date: Optional<string>;
  carrier: string;
  tracker_details: ITrackerDetail[];
  tracking_url: Optional<string>;
  label_url: Optional<string>;
}

/** matches shipping CommonShipmentSerializer */
export interface IShipment {
  id: number;
  tracker: Optional<ITracker>;
  last_updated: Optional<string>;
  status_display: string;
}

/** matches shipping TrackerStatus */
export enum TrackerStatus {
  Unknown = "UNKNOWN",
  PreTransit = "PRE_TRANSIT",
  InTransit = "IN_TRANSIT",
  OutForDelivery = "OUT_FOR_DELIVERY",
  Delivered = "DELIVERED",
  ReturnToSender = "RETURN_TO_SENDER",
  AvailableForPickup = "AVAILABLE_FOR_PICKUP",
  Failure = "FAILURE",
  Cancelled = "CANCELLED",
  Error = "ERROR",
}

/* Matches shipping ShippingRate */
export interface SummaryShippingRate {
  display: string;
  cost: Optional<number>;
  is_eligible_for_free_over: boolean;
}

/* Matches shipping ShippingRateSummary */
export interface ShippingRateSummary {
  primary: SummaryShippingRate[];
  compound: SummaryShippingRate[];
  diet: SummaryShippingRate;
  free_shipping_over: Optional<number>;
  compound_vendor_name: Optional<string>;
}
